import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { ConfirmingReportListTemplate } from "themes/application/confirming-report/pages";
import { ConfirmingReportListViewStore } from "application/confirming-report/stores";

@setCurrentView(rootStore => new ConfirmingReportListViewStore(rootStore), "confirmingReportListViewStore")
@observer
class ConfirmingReportList extends React.Component {
    render() {
        return <ConfirmingReportListTemplate {...this.props} />;
    }
}

export default ConfirmingReportList;